import createVueApp from '@/common/createApp'

Styxie.Initializers.MlapSettingsAudits = {
  index: async(props) => {
    const { default: AuditsSettings } = await import('@/vue_widgets/mlap/settings/audits/index.vue')
    createVueApp(AuditsSettings, { props })
  }
}
